import React from 'react'

export function DiscountsListStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .close-btn {
          padding-left: 6px;
          padding-right: 7px;
          padding-top: 5px;
          padding-bottom: 4px;
          border-radius: 50px;
          background-color: red;
          border: none;
          margin: auto;
          font-size: 0.8em;
        }
        .close-btn:hover {
          border: none;
        }
        .close-btn:focus {
          border: none;
        }

        #discounts-list-container {
          border-left: solid 1px lightblue;
          /*background-color: green;*/
          display: flex;
          flex-direction: column;
          flex: 3;
          padding: 10px;
          overflow: auto;
        }
        #discounts-list-body {
          height: 100%;
          overflow: auto;
          padding: 10px;
          border: inset 1px;
          /*background-color: whitesmoke;*/
        }
        #discount-list-total-container {
          /*background-color: orange;*/
          display: flex;
          flex-direction: column;
          align-content: flex-end;
          font-size: 0.8em;
        }
        .discount-total {
          display: flex;
          /*background-color: pink;*/
          /*align-self: flex-end;*/
          /*width: 70%;*/
        }

        .discount-total label {
          flex: 1;
          font-size: 0.8em;
          /*background-color: violet;*/
        }

        .discount-total span {
          /*background-color: red;*/
          text-align: right;
        }

        .discount-item-container {
          border-radius: 20px;
          font-size: 0.65em;
          display: flex;
          flex-direction: column;
          background-color: purple;
          color: whitesmoke;
          padding: 10px;
          margin-bottom: 3px;
        }
        .shadow-discount-item {
          box-shadow: 2px 2px 10px 2px #BBB;
          background-color: rgba(100, 20, 155, 0.8);
        }

        .disable-discount-item {
          background-color: grey;
          color:lightgrey;
        }

        .discount-item-container:hover * {
          cursor: pointer;
        }
        .discount-item-container:hover {
          /*
          box-shadow: 2px 2px 10px 2px #BBB;
          background-color: rgba(100, 20, 155, 0.8);
          */
        }

        .discount-item {
          display: flex;
        }

        .discount-item-header {
          color: white;
          font-weight: bold;
          display: flex;
        }
        .discount-item-header label {
          flex: 1;
        }
        .discount-item-header span {
          flex: 1;
          text-align: right;
        }
        .discount-item label {
          flex: 1;
        }
        .discount-item span {
          flex: 1;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function DiscountInputStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /*
        .pospro-action-btn.disabled-button {
          background-color: rgba(122, 122, 122, 1);
          color: rgba(72, 72, 72, 1);
        }
        */

        #sales-amount {
          background-color: orange;
          display: flex;
          padding: 10px;
        }
        #sales-amount label {
          flex: 1;
        }
        #sales-amount span {
          flex: 1;
          text-align: right;
        }
        #discount-input-container {
          font-size: 0.65em;
          /*background-color: blue;*/
          flex: 2;
        }

        .button-container {
          display: flex;
          padding: 10px;
          justify-content: flex-end;
        }

        .input-form-container {
          /*background-color: yellow;*/
          display: flex;
          flex-direction: column;
          padding: 10px;
        }

        .input-form-container label {
          flex: 1;
        }
        .input-form-container .input-container {
          /*background-color: orange;*/
          display: flex;
          flex-direction: column;
          flex: 2;
          margin-top: 5px;
        }
        .input-form-container .checkbox-container {
          display: flex;
          flex: 2;
          margin-top: 5px;
        }
        .input-container input {
          padding: 5px;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function DiscountFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* MODAL FORM this is for discount form */
        /*
        .modal-content-container.discount {
          margin: 1% auto;
          width: 65%;
        }
        .modal-content-container.discount .modal-form-contents {
          height: 80vh;
          overflow: auto;
        }
        */
        /* MODAL FORM END */

        #discount-form-container {
          height: 100%; /* It's should be declared first */
          /*background-color: violet;*/
          display: grid;
          grid-template-columns: 1fr;
          grid-template-rows: 1fr auto;
          grid-template-areas:
              "body"
              "footer";
          overflow: auto;
        }
        #discount-form-body {
          grid-area: body;
          /*background-color: pink;*/
          display: flex;
          height: 100%;
          overflow: auto;
        }
        #discount-form-footer {
          grid-area: footer;
          display: flex;
          padding: 10px;
          justify-content: flex-end;
          /*background-color: maroon;*/
        }

        .acl-container {
          position: relative;
          text-align: left;
          font-size: 16px;
          font-weight: normal;
        }
      `}
      </style>
    </React.Fragment>
  )
}
